// extracted by mini-css-extract-plugin
export default {"headerWrapper":"style_headerWrapper__tc5cF","headerContent":"style_headerContent__Dtd9R","contentWrapper":"style_contentWrapper__HsrDS","ellipsisLabel":"style_ellipsisLabel__3789u"};